// Action creators extracted from Services.js

import {
  SET_IS_ONLINE,
  SET_IS_PAGE_NOT_FOUND,
  SET_IS_AI_USAGE_LIMIT_MODAL,
  SET_PROGRESS,
  REMOVE_PROGRESS_ELEMENT,
  UPDATE_LOCAL_COMMENT,
  SET_ORDER_BY_DIRECTION,
  TOGGLE_ACTION_LOADING,
  UPDATE_AUDIO_RECORDER_BLOB,
  SET_PICTURE_IN_PICTURE_DATA,
  UPDATE_GLOBAL_SEARCH_TEXT,
  SET_GLOBAL_SEARCH_FILTER_MODULE,
  TOGGLE_GLOBAL_SEARCH_MODULE,
  TOGGLE_GLOBAL_SEARCH_VOICE_MODULE,
  TOGGLE_GLOBAL_SEARCH_AND_VOICE_MODULE,
  SET_GLOBAL_SEARCH_COURSES_CONTEXT,
  SET_GLOBAL_SEARCH_CURRICULUM_CONTEXT,
  SET_JUMP_TO_CURRICULUM_CONTEXT,
  SET_UBD_ASSESSMENT_TYPES,
  SHOW_INTERCOM,
  HIDE_INTERCOM,
  SHOW_NOTIFICATION_ICON_GLOBAL_TRAY,
  HIDE_NOTIFICATION_ICON_GLOBAL_TRAY,
  ADD_FEATURE_WITH_KEYBOARD_SHORTCUTS,
  REMOVE_FEATURE_WITH_KEYBOARD_SHORTCUTS,
  SET_ACTIVE_FEATURE_WITH_KEYBOARD_SHORTCUTS,
  SET_AUDIO_RECORDER_ACTIVE,
  SET_NEW_PRODUCT_UPDATES_CALL_OUT_STATE,
  SET_BADGE_OPTIMISTIC_STATE,
  SET_PLATFORM_SWITCHER_TAB,
  SET_IS_RESOURCE_UNAVAILABLE,
} from "./ServicesConstants";

// Action Creators
export const updateAudioRecorderBlob = blobObject => {
  return { type: UPDATE_AUDIO_RECORDER_BLOB, payload: blobObject };
};

export const setAudioRecorderActive = value => {
  return { type: SET_AUDIO_RECORDER_ACTIVE, payload: value };
};

export const setPictureInPictureConfig = data => {
  return { type: SET_PICTURE_IN_PICTURE_DATA, data };
};

export const setIsOnline = value => {
  return { type: SET_IS_ONLINE, payload: value };
};

/**
 * @deprecated since version release-v1.59.4. Will be deleted in version release-v1.65.0
 * Use goToPageNotFound instead.
 */
export const setIsPageNotFound = value => {
  return { type: SET_IS_PAGE_NOT_FOUND, payload: value };
};

export const setIsResourceUnavailable = value => {
  return { type: SET_IS_RESOURCE_UNAVAILABLE, payload: value };
};

export const setIsAIUsageLimitModalOpen = value => {
  return { type: SET_IS_AI_USAGE_LIMIT_MODAL, payload: value };
};

export const setNewProductUpdatesCalloutState = value => {
  return { type: SET_NEW_PRODUCT_UPDATES_CALL_OUT_STATE, payload: value };
};

export const setBadgeOptimisticState = value => {
  return { type: SET_BADGE_OPTIMISTIC_STATE, payload: value };
};

export const setProgress = value => {
  return { type: SET_PROGRESS, payload: value };
};

export const setOrderByDirection = data => {
  return { type: SET_ORDER_BY_DIRECTION, data };
};

export const toggleActionLoading = data => {
  return {
    type: TOGGLE_ACTION_LOADING,
    data,
  };
};

export const updateLocalComment = data => {
  return {
    type: UPDATE_LOCAL_COMMENT,
    data,
  };
};

export const removeProgressElement = value => {
  return { type: REMOVE_PROGRESS_ELEMENT, payload: value };
};

export const addFeaturesWithKeyboardShortcuts = features => {
  return {
    type: ADD_FEATURE_WITH_KEYBOARD_SHORTCUTS,
    payload: features,
  };
};

export const removeFeaturesWithKeyboardShortcuts = features => {
  return {
    type: REMOVE_FEATURE_WITH_KEYBOARD_SHORTCUTS,
    payload: features,
  };
};

export const setActiveFeatureWithKeyboardShortcuts = feature => {
  return {
    type: SET_ACTIVE_FEATURE_WITH_KEYBOARD_SHORTCUTS,
    payload: feature,
  };
};

//this is to toggle voice search on global search bar
export const toggleVoiceSearch = data => {
  return { type: TOGGLE_GLOBAL_SEARCH_VOICE_MODULE, payload: data };
};

//this is to toggle modal state for global search bar
export const toggleGlobalSearchBarModal = () => {
  return { type: TOGGLE_GLOBAL_SEARCH_MODULE };
};

export const toggleSearchAndVoiceModule = () => {
  return { type: TOGGLE_GLOBAL_SEARCH_AND_VOICE_MODULE };
};

export const updateGlobalSearchText = data => {
  return { type: UPDATE_GLOBAL_SEARCH_TEXT, payload: data };
};

export const updateGlobalSearchModuleFilter = data => {
  return { type: SET_GLOBAL_SEARCH_FILTER_MODULE, payload: data };
};

export const updateGlobalSearchCoursesContext = data => {
  return { type: SET_GLOBAL_SEARCH_COURSES_CONTEXT, payload: data };
};

export const updateGlobalSearchCurriculumContext = data => {
  return { type: SET_GLOBAL_SEARCH_CURRICULUM_CONTEXT, payload: data };
};

export const updateJumpToCurriculumContext = data => {
  return { type: SET_JUMP_TO_CURRICULUM_CONTEXT, payload: data };
};

export const updateUbdAssessmentTypes = data => {
  return { type: SET_UBD_ASSESSMENT_TYPES, payload: data };
};

export const showIntercom = data => {
  return { type: SHOW_INTERCOM, payload: data };
};

export const hideIntercom = data => {
  return { type: HIDE_INTERCOM, payload: data };
};

export const showNotificationIconFromGlobalTray = data => {
  return { type: SHOW_NOTIFICATION_ICON_GLOBAL_TRAY, payload: data };
};

export const hideNotificationIconFromGlobalTray = data => {
  return { type: HIDE_NOTIFICATION_ICON_GLOBAL_TRAY, payload: data };
};

export const setPlatformSwitcherTab = tabName => {
  return { type: SET_PLATFORM_SWITCHER_TAB, payload: tabName };
};
